import React from "react";

import { useViewport } from "../hooks/useViewport.hook";
import { Links } from "../vehicle-search-details/vehicleSearch.type";
import StickyFooterDesktop from "./StickyFooterDesktop";
import StickyFooterMobile from "./StickyFooterMobile";

export interface StickyFooterProps {
  selectedVehicles: string[];
  setSelectedVehicles: React.Dispatch<React.SetStateAction<any[]>>;
  printLink?: Links;
  exportLink?: Links;
  pdfEnabled?: boolean;
}

const StickyFooter: React.FunctionComponent<StickyFooterProps> = ({
  selectedVehicles,
  setSelectedVehicles,
  printLink,
  exportLink,
  pdfEnabled,
}) => {
  const viewportWidth = useViewport(0);

  return (
    <>
      {(viewportWidth === "mobile" || viewportWidth === "tablet") && (
        <StickyFooterMobile
          selectedVehicles={selectedVehicles}
          setSelectedVehicles={setSelectedVehicles}
          printLink={printLink}
          exportLink={exportLink}
          pdfEnabled={pdfEnabled}
        />
      )}
      {(viewportWidth === "desktop" || viewportWidth === "smallDesktop") && (
        <StickyFooterDesktop
          selectedVehicles={selectedVehicles}
          setSelectedVehicles={setSelectedVehicles}
          printLink={printLink}
          exportLink={exportLink}
          pdfEnabled={pdfEnabled}
        />
      )}
    </>
  );
};

export default StickyFooter;
